import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=5b727dfc&scoped=true&"
import script from "./AccountLayout.vue?vue&type=script&lang=js&"
export * from "./AccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=5b727dfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b727dfc",
  null
  
)

export default component.exports